module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user && _vm.user.workers.length > 0) ? _c('gauge', {
    attrs: {
      "title": "Hashrate worker 1",
      "width": "235",
      "height": "246",
      "unit": "sol/s",
      "value": _vm.user.workers[0].hashrate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user && _vm.user.workers.length > 1) ? _c('gauge', {
    attrs: {
      "title": "Hashrate worker 2",
      "width": "235",
      "height": "246",
      "unit": "sol/s",
      "value": _vm.user.workers[1].hashrate
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "address",
      "unit": "",
      "value": _vm.user.account
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "Unconfirmed Pool Balance",
      "unit": "zec",
      "value": _vm.user.unconfirmed_balance
    }
  }) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('panel', {
    attrs: {
      "title": "Pool Balance",
      "unit": "zec",
      "value": _vm.user.balance
    }
  }, [_c('div', {
    staticClass: "line",
    style: ({
      width: (_vm.user.balance / 0.01) * 100 + '%'
    })
  })]) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "outside temperature",
      "unit": "°C",
      "value": _vm.stats.outsidetemp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "GPU load",
      "unit": "W",
      "value": _vm.stats.load
    }
  }) : _vm._e(), _vm._v(" "), (_vm.stats) ? _c('panel', {
    attrs: {
      "title": "GPU temp",
      "unit": "°C",
      "value": _vm.stats.gputemp
    }
  }) : _vm._e(), _vm._v(" "), (_vm.payments) ? _c('panel', {
    attrs: {
      "title": "payouts",
      "unit": "",
      "value": _vm.payments.length
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastblocknumber) ? _c('panel', {
    attrs: {
      "title": "last block number",
      "unit": "",
      "value": _vm.lastblocknumber
    }
  }) : _vm._e(), _vm._v(" "), (_vm.avgblocktime) ? _c('panel', {
    attrs: {
      "title": "avg blocktime",
      "unit": "seconds",
      "value": _vm.avgblocktime.toFixed(2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalpayout) ? _c('panel', {
    attrs: {
      "title": "total mined",
      "unit": "zec",
      "value": _vm.totalpayout.toFixed(4)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.totalpayoutEur) ? _c('panel', {
    attrs: {
      "title": "total mined",
      "unit": "€",
      "value": _vm.totalpayoutEur
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lastblocks) ? _c('list', {
    attrs: {
      "title": "Last block",
      "data": _vm.lastblocks
    }
  }) : _vm._e(), _vm._v(" "), (_vm.priceHistory) ? _c('linechartsmall', {
    attrs: {
      "title": "ZEC price history",
      "width": "550",
      "height": "173",
      "unit": "$",
      "data": _vm.priceHistory,
      "margin": {
        top: 0,
        right: 45,
        bottom: 20,
        left: 15
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02bc8f7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
// module id = 785
// module chunks = 1